import PropTypes from 'prop-types';
import { headerTranslationKeys } from '../Header/propTypes';

const footerTranslationKeys = {
    logoAlt: PropTypes.string.isRequired,
    footerCategoriesHeading: PropTypes.string.isRequired,
    footerForBuyersHeading: PropTypes.string.isRequired,
    footerForOrganisersHeading: PropTypes.string.isRequired,
    footerInformationHeading: PropTypes.string.isRequired,
    footerNewsletterHeading: PropTypes.string.isRequired,
    footerNewsletterDescription: PropTypes.string.isRequired,
    footerNewsletterPlaceholder: PropTypes.string.isRequired,
    footerNewsletterSubmit: PropTypes.string.isRequired,
    footerNewsletterInvalidEmail: PropTypes.string.isRequired,
    footerNewsletterLoading: PropTypes.string.isRequired,
    footerNewsletterSuccess: PropTypes.string.isRequired,
    footerNewsletterError: PropTypes.string.isRequired,
    footerNewsletterConsentLabel: PropTypes.string.isRequired,
    footerMyTickets: PropTypes.string.isRequired,
    footerGetYourTicket: PropTypes.string.isRequired,
    footerPrivacyPolicy: PropTypes.string.isRequired,
    footerTermsOfService: PropTypes.string.isRequired,
    footerContacts: PropTypes.string.isRequired,
    footerFaq: PropTypes.string.isRequired,
    footerValidateTickets: PropTypes.string.isRequired,
    footerCreateEvent: PropTypes.string.isRequired,
    footerPricing: PropTypes.string.isRequired,
    footerAgreementForOrganisers: PropTypes.string.isRequired,
    footerPersonalDataProcessing: PropTypes.string.isRequired,
    footerAffiliate: PropTypes.string.isRequired,
    footerLogos: PropTypes.string.isRequired,
    footerAdvertisement: PropTypes.string.isRequired,
    footerReport: PropTypes.string.isRequired,
    footerAboutSystem: PropTypes.string.isRequired,
    footerPaymentServicesAgreementPrivate: PropTypes.string.isRequired,
    footerPaymentServicesAgreementBusiness: PropTypes.string.isRequired,
    footerSocialFacebook: PropTypes.string.isRequired,
    footerSocialInstagram: PropTypes.string.isRequired,
    footerCopyright: PropTypes.string.isRequired,
    footerPoweredBy: PropTypes.string.isRequired,
};

export const layoutTranslationsShape = PropTypes.shape({
    ...headerTranslationKeys,
    ...footerTranslationKeys,
});

export const footerTranslationsShape = PropTypes.shape(footerTranslationKeys);

export const footerLinksShape = PropTypes.shape({
    myTickets: PropTypes.string,
    getYourTicket: PropTypes.string,
    privacyPolicy: PropTypes.string,
    termsOfService: PropTypes.string,
    contacts: PropTypes.string,
    organiserContacts: PropTypes.string,
    faq: PropTypes.string,
    validateTickets: PropTypes.string,
    createEvent: PropTypes.string,
    pricing: PropTypes.string,
    agreementForOrganisers: PropTypes.string,
    personalDataProcessing: PropTypes.string,
    affiliate: PropTypes.string,
    logos: PropTypes.string,
    advertisement: PropTypes.string,
    report: PropTypes.string,
    aboutSystem: PropTypes.string,
    paymentServicesAgreementPrivate: PropTypes.string,
    paymentServicesAgreementBusiness: PropTypes.string,
    facebook: PropTypes.string,
    instagram: PropTypes.string,
});
